"use strict"

import Codec from "./codec"
import {
  OrganizationUsageStats,
  OrganizationMetricsData,
} from "../domain/organization-usage-stats"
import OrganizationCodec from "./organization-codec"

/**

 Encodes/Decodes organization usage stats
 */
export class OrganizationUsageStatsCodec extends Codec {
  constructor() {
    super()
  }

  /**

   @param value {OrganizationUsageStats}
   @return {
    {total_teachers: number,
    total_assignments: number,
    total_students: number,
    total_help_requests_resolved: number,
    active_teachers: object[],
    teachers_active_this_year: number,
    students_active_this_year: number,
    assignments_created_this_year: number,
    assignments_worked_on_this_year: number,
    assignment_questions_worked_on_this_year: number,
    assignment_questions_worked_on_12_months: number,
    rosters_created_this_year: number,
    help_requests_resolved_this_year: number,
    }}
   */
  encode(value) {
    return {
      total_teachers: value.totalTeachers,
      total_assignments: value.totalAssignments,
      total_students: value.totalStudents,
      total_help_requests_resolved: value.totalHelpRequestsResolved,
      active_teachers: value.activeTeachers,
      teachers_active_this_year: value.teachersActiveThisYear,
      students_active_this_year: value.studentsActiveThisYear,
      assignments_created_this_year: value.assignmentsCreatedThisYear,
      assignments_worked_on_this_year: value.assignmentsWorkedOnThisYear,
      assignment_questions_worked_on_this_year:
        value.assignmentQuestionsWorkedOnThisYear,
      assignment_questions_worked_on_12_months:
        value.assignmentQuestionsWorkedOn12Months,
      rosters_created_this_year: value.rostersCreatedThisYear,
      help_requests_resolved_this_year: value.helpRequestsResolvedThisYear,
    }
  }

  /**

     @param value {Object}
     @return {OrganizationUsageStats|null}
     */
  decode(value) {
    if (value) {
      return new OrganizationUsageStats(
        value.total_teachers,
        value.total_assignments,
        value.total_students,
        value.total_help_requests_resolved,
        value.active_teachers,
        value.teachers_active_this_year,
        value.students_active_this_year,
        value.assignments_created_this_year,
        value.assignments_worked_on_this_year,
        value.assignment_questions_worked_on_this_year,
        value.assignment_questions_worked_on?.twelve_month,
        value.rosters_created_this_year,
        value.help_requests_resolved_this_year,
      )
    } else {
      return null
    }
  }
}

export default OrganizationUsageStatsCodec

export class OrganizationMetricsDataCodec extends Codec {
  constructor() {
    super()
  }

  encode(value) {
    return {
      organization: new OrganizationCodec().encode(value.organization),
      stats: new OrganizationUsageStatsCodec().encode(value.stats),
      is_pro: value.isPro,
    }
  }

  decode(value) {
    if (value) {
      return new OrganizationMetricsData(
        new OrganizationCodec().decode(value.organization),
        new OrganizationUsageStatsCodec().decode(value.stats),
        value.is_pro,
      )
    }
  }
}
